import { Seg } from "./components/Seg.js";
import type { Landing, Prefs, Theme } from "./prefs.js";

const THEMES = [
  ["system", "Auto"],
  ["light", "Light"],
  ["dark", "Dark"],
] as const satisfies readonly (readonly [Theme, string])[];

export function Settings({
  prefs,
  admin,
  update,
  reset,
}: {
  prefs: Prefs;
  admin: boolean;
  update: (p: Partial<Prefs>) => void;
  reset: () => void;
}) {
  const landing: (readonly [Landing, string])[] = [["ask", "Ask HR"], ...(admin ? [["admin", "Admin"] as const] : [])];
  return (
    <>
      <section className="panel">
        <h2>Appearance</h2>
        <div className="set-row">
          <span className="lbl">
            Color theme<small>Auto follows your device setting</small>
          </span>
          <Seg label="Color theme" value={prefs.theme} options={THEMES} onChange={(t) => update({ theme: t })} />
        </div>
      </section>
      {admin ? (
        <section className="panel">
          <h2>Start page</h2>
          <div className="set-row">
            <span className="lbl">
              Open to<small>The page you see when you sign in</small>
            </span>
            <Seg label="Start page" value={prefs.landing} options={landing} onChange={(l) => update({ landing: l })} />
          </div>
        </section>
      ) : null}
      <section className="panel">
        <p className="note">Settings are saved in this browser only and stay until you reset them.</p>
        <button type="button" onClick={reset}>
          Reset settings
        </button>
      </section>
    </>
  );
}
